import { render } from "./Main.vue?vue&type=template&id=5e2a0c2c&scoped=true"
import script from "./Main.vue?vue&type=script&lang=js"
export * from "./Main.vue?vue&type=script&lang=js"

import "./Main.vue?vue&type=style&index=0&id=5e2a0c2c&lang=scss&scoped=true"

import exportComponent from "C:\\developmentGIT\\Pirca\\PircaSolutions.Forge.PrimeraEntrevista\\PircaSolutions.Forge.PrimeraEntrevista.UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5e2a0c2c"]])

export default __exports__